import { render, staticRenderFns } from "./ParentGroupComponent.vue?vue&type=template&id=4d531ecc&scoped=true"
import script from "./ParentGroupComponent.vue?vue&type=script&lang=ts"
export * from "./ParentGroupComponent.vue?vue&type=script&lang=ts"
import style0 from "./ParentGroupComponent.vue?vue&type=style&index=0&id=4d531ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d531ecc",
  null
  
)

export default component.exports